<template>
    <div class="w-full space-y-3">
        <Head title="Expenses"/>
        <div class="flex justify-between">
            <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl">Expenses</h1>
        </div>
        <div class="w-full flex gap-3 justify-between">
            <div class="flex gap-3 w-full">
                <span @click="emitter.emit('openExpenseSlideout')"
                      class="cursor-pointer inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <svg class="-ml-0.5 mr-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                         stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    Add New Expense
                </span>
<!--                <span @click="emitter.emit('openManageCards')"-->
<!--                      class="cursor-pointer inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase bg-amaze-coral focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">-->
<!--                    <CreditCardIcon class="-ml-0.5 mr-2 h-4 w-4"/>-->
<!--                    Manage Cards-->
<!--                </span>-->
            </div>
        </div>
        <div class="w-full flex gap-3 justify-between">
            <div class="flex gap-1 w-full items-center justify-between items-center">
                <div class="flex gap-2 w-1/3">
                    <div class="w-1/2">
                        <label for="company-website" class="block text-sm font-medium text-gray-700">Date From</label>
                        <div class="relative mt-1 rounded-md shadow-sm">
                            <input v-model="form.filter.date_from"  :max="form.filter.date_to ?? moment().format('YYYY-MM-DD')" type="date" class="block w-full rounded-md border-gray-300  focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" placeholder="www.example.com">
                        </div>
                    </div>
                    <div class="w-1/2">
                        <label for="company-website" class="block text-sm font-medium text-gray-700">Date To</label>
                        <div class="relative mt-1 rounded-md shadow-sm">
                            <input v-model="form.filter.date_to"  :min="form.filter.date_from ?? moment().format('YYYY-MM-DD')" type="date" class="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" placeholder="www.example.com">
                        </div>
                    </div>
                </div>
                <div>
                     <a :href="'/expenses/download?date_from=' + this.form.filter.date_from + '&date_to=' + this.form.filter.date_to" @click="exportExpenses()"
                           class="cursor-pointer inline-flex items-center px-4 py-2 bg-gray-500 border border-transparent rounded-md font-semibold text-xs text-white uppercase focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                    <DownloadIcon class="-ml-0.5 mr-2 h-4 w-4" />
                    Export Expenses
                </a>
                </div>
            </div>
        </div>
        <div class="bg-white py-6 px-4 sm:p-6 shadow mb-6">
            <div class="flex flex-col mt-3 space-y-3">
                <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                        <div class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                            <table class="min-w-full divide-y divide-gray-200">
                                <thead class="bg-gray-50">
                                <tr>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Description
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Project
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Payment Date
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Amount
                                    </th>

                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Expense Type
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        Transaction Type
                                    </th>
                                    <th scope="col"
                                        class="px-6 py-3 text-left text-xs text-gray-500 uppercase tracking-wider">
                                        &nbsp;
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-if="expenses.data.length > 0" v-for="(expense,index) in expenses.data"
                                    :key="index"
                                    :class="{'bg-gray-100': index % 2}"
                                    class="hover:bg-gray-50 cursor-pointer">
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900"
                                        v-html="expense.description">
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        <Link class="underline" v-if="expense.project !== null" :href="route('frontend.project.show', expense.project.id)">{{ expense.project.title }}</Link>
                                        <span v-else>----</span>
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ moment(expense.paid_at, 'YYYY-MM-DD').format('DD-MM-YYYY') }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ formatCurrency(expense.amount, expense.project.bank_account.currency.code, true) }}
                                    </td>

                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ expense.expense_type.name }}
                                    </td>
                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        {{ expense.transaction_type.name }} <br/>
                                        <span class="w-full text-gray-400">{{ expense.transaction_type.title }}</span>
                                    </td>

                                    <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900 flex">
                                        <PencilAltIcon @click="emitter.emit('editExpenseSlideout', expense)"
                                                       class="w-4 h-4 mr-3"></PencilAltIcon>
                                        <TrashIcon @click="deleteExpense(expense.id)"
                                                   class="w-4 h-4 text-red-500"></TrashIcon>
                                    </td>
                                </tr>
                                <tr v-else>
                                    <td colspan="8"
                                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                        There are no expenses available for your search criteria.
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
<!--    <ManageCards/>-->
</template>

<script>
import Authenticated from "@/Layouts/Authenticated.vue";
import {Link, Head, useForm} from "@inertiajs/vue3";
import {emitter} from "@/eventHub";
import {CreditCardIcon, TrashIcon, PencilAltIcon, DownloadIcon} from "@heroicons/vue/outline";
// import ManageCards from "@/Components/SlideOuts/ManageCards";
import moment from "moment";
import debounce from "lodash/debounce";
import pickBy from "lodash/pickBy";


export default {
    layout: Authenticated,
    components: {
        // ManageCards,
        Head,
        Link,
        CreditCardIcon,
        TrashIcon,
        PencilAltIcon,
        DownloadIcon
    },
    data() {
        return {
            emitter,
            form: useForm({
                search: null,
                filter: {
                    date_from: "",
                    date_to: ""
                }
            })
        }
    },
    created() {
        this.moment = moment
    },
    props: {
        expenses: Object
    },
    methods: {
        deleteExpense(id) {
            this.$swal.fire({
                title: 'Remove Expense',
                html: "You are removing an expense. <br/>Are you sure you'd like to do this?",
                showCloseButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No'
            })
                .then((result) => {
                    if (result.isConfirmed) {
                        // Delete the country
                        Inertia.delete(route('frontend.expenses.expense.delete', id), {
                            preserveScroll: true
                        });
                    }
                });
        },
    },
    watch: {
        form: {
            deep: true,
            handler: debounce(function () {
                this.$inertia.get(route('frontend.expenses.index'), pickBy(this.form), {preserveState: true, preserveScroll: true})
            }, 500),
        },
    },
}
</script>
